// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"484":"3b842b6e","498":"3b842b6e"}[chunkId] + ".chunk.css");